import React, { useEffect, useLayoutEffect, useState } from "react";
import { Grid } from "@mui/material";
import RightPartRegistration from "./rightPartRegistration";
import palette from "../../theme/palette";
import RightPartCodeVerify from "./rightPartCodeVerify";
import { xVersion } from "../../services/config";
import OnBoardingWithSteps from "./onboardingSteps";
import ConfettiTNT from "../insightsV2/common/confetti";
import useWidth from "../../utils/useWidth";
import { useNavigate } from "react-router-dom";


const OnBoarding = () => {
  const [codeVerified, setCodeVerified] = useState(xVersion ? true : false)
  // localStorage.removeItem("userDetails");
  // localStorage.removeItem("userValues");
  // localStorage.removeItem("userId");
  // localStorage.removeItem("userDate");
  const width = useWidth()
  const navigate = useNavigate()
  const isMobile = width < 768
  const [visible, setVisible] = useState(false)
  // useEffect(() => {
  //   setTimeout(() => {
  //     console.log("isMobile setTimeout", isMobile);
  //     if (isMobile) {
  //       navigate("/register")
  //     }
  //   }, 500)
  // }, [isMobile, navigate])
  return (
    <Grid
      container
      alignItems="center"
      columns={16}
      sx={{ backgroundColor: palette.common.white }}
    >

      {/* START RIGHT SECTION */}
      <Grid item xs={24} className="rightside-menu" style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        filter: visible && "blur(3px)"
      }}>
        <OnBoardingWithSteps setVisible={setVisible} />
      </Grid>
      {/* END RIGHT SECTION */}
      {visible && <ConfettiTNT />}

    </Grid>
  );
};
export default OnBoarding;
